import React from 'react';
import ReactDOM from 'react-dom';

//redux
import { Provider } from 'react-redux';
import store from './store';

import { Router, Switch, Redirect } from 'react-router-dom';
import { GuardProvider, GuardedRoute } from 'react-router-guards';

import Landing from './views/Landing';
import Search from './views/Search';
import Details from './views/Details';
import * as serviceWorker from './serviceWorker';

import { hotjar } from 'react-hotjar';
import ReactGA from 'react-ga';
import Analytics from 'react-router-ga';

import history from './history';

import ServicesSearch from './services/ServicesSearch';

// import updateParams from './store/params/action';
// import {connect} from 'react-redux';

// Inicialización de herramientas de métricas
const trackingId = (process.env.NODE_ENV === 'development')?"UA-164227587-3":"UA-177636276-1"; // DEV de C2C, PRD de Ministerio
const hotjarId = (process.env.NODE_ENV === 'development')?1988790:1987259; // DEV de C2C, PRD de Ministerio


ReactGA.initialize(trackingId);
//ReactGA.set({ page: "search" });
//ReactGA.pageview("search");
hotjar.initialize(hotjarId, 6);


const validateIfActive = (to, from, next) => {
  ServicesSearch.isRedirected()
    .then((response) => {
      if(response.data && response.data.active){
        return next();
      }

      window.location.replace('https://www.comprapyme.cl/home.html');
    })
    .catch((err) => {
      console.log(err);
      window.location.replace('https://www.comprapyme.cl/home.html');
    });
};

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
     <div>
       <GuardProvider guards={[validateIfActive]}>
        <Analytics id={trackingId} debug>
         <Switch>
          <GuardedRoute exact path="/pyme/details/:rut?" component={Details} />
          <GuardedRoute exact path="/search/:id?" component={Search}/>
          <GuardedRoute exact path="/" component={Landing} />
          <Redirect from="*" to="/"/>
         </Switch>
        </Analytics>
       </GuardProvider>
     </div>
    </Router>
  </Provider>,
  document.getElementById('root')
);

serviceWorker.unregister();
